import type { WikiPerson } from './people-wiki.types';

const searchableValues = (person: WikiPerson): (string | null)[] => [
  person.name,
  person.primaryEmail,
  ...person.otherEmails,
  ...person.aliases,
  ...person.accounts.map(({ label }) => label),
];

/** The people who are in the wiki. A person who only asked to connect is listed under Requests until the request is
 * accepted, so the tables and pickers leave them out. */
export const withoutRequestOnly = (people: WikiPerson[]): WikiPerson[] =>
  people.filter(({ isRequestOnly }) => !isRequestOnly);

/** The people the user can message with Hive Mind now. */
export const reachablePeople = (people: WikiPerson[]): WikiPerson[] =>
  people.filter(({ isOnHiveMind }) => isOnHiveMind);

/** The address that Hive Mind reaches a person at, which names them when a group is saved. */
export const hiveMindEmail = (person: WikiPerson): string | undefined =>
  person.littlebirdAccounts.find(({ hiveMind }) => hiveMind)?.email;

export const filterPeople = (
  people: WikiPerson[],
  query: string
): WikiPerson[] => {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery === '') {
    return people;
  }
  return people.filter((person) =>
    searchableValues(person).some((value) =>
      value?.toLowerCase().includes(normalizedQuery)
    )
  );
};
